export { default as default } from './JocCard';
